// extracted by mini-css-extract-plugin
export default {"pie-chart":"ActiveStudent_pie-chart__+u-eb"};